/*global jQuery*/
(function ($) {
    'use strict';

    $.fn.topVideoUnknown = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('topVideoUnknown');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.topVideoUnknown.defaults,
                    typeof option === 'object' && option
                );

                $element.data('topVideoUnknown', (ctrl = new TopVideoUnknown(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.topVideoUnknown.defaults = {
        onReady: null,
        onEnded: null, // This never completes
    };

    function TopVideoUnknown(element, options) {
        this.init(element, options);
    }

    TopVideoUnknown.prototype = {
        constructor: TopVideoUnknown,

        // Properties
        $iframe: null,

        // Methods
        /**
         * @private
         * @param {jQuery} element
         * @param {object} options
         */
        init: function (element, options) {
            this.options = options;
            this.$element = $(element);
            this.onEnded = options.onEnded ? [options.onEnded] : [];
            this.onReady = options.onReady ? [options.onReady] : [];
            this._muted = false;

            this.$iframe = this.$element.find('iframe');
            this._notifyReady();
        },

        play: function () { },
        mute: function () {
            this._muted = true;
        },

        unmute: function () {
            this._muted = false;
        },

        destroy: function () { },

        get isMuted() {
            return this._muted;
        },

        /** @return {number} */
        get playerWidth() {
            return this.$iframe.width();
        },

        /** @return {number} */
        get playerHeight() {
            return this.$iframe.height();
        },

        /** @private */
        _notifyReady: function () {
            this.onReady.forEach(function (callback) {
                callback(this);
            });
        }
    };
})(jQuery);
